<span class="slider-range" *ngIf="rangeVisible" [ngStyle]="rangeStyles"></span>

<span
    #handle
    class="slider-handle"
    [ngStyle]="minHandleStyles"
    [ngClass]="{ 'slider-handle-active': currentHandle === handleType.MinHandle, 'slider-active': active }"
    [attr.tabindex]="tabindex"
    (keydown)="onHandleKeydown($event, handleType.MinHandle)"
    (mousedown)="onMouseDown($event, handleType.MinHandle)"
    (touchstart)="onTouchStart($event, handleType.MinHandle)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd()">
    <ng-container *ngIf="minIconTemplate" [ngTemplateOutlet]="minIconTemplate"></ng-container>
</span>

<span
    class="slider-handle"
    *ngIf="range"
    [ngStyle]="maxHandleStyles"
    [ngClass]="{ 'slider-handle-active': currentHandle === handleType.MaxHandle }"
    [attr.tabindex]="tabindex"
    (keydown)="onHandleKeydown($event, handleType.MaxHandle)"
    (mousedown)="onMouseDown($event, handleType.MaxHandle)"
    (touchstart)="onTouchStart($event, handleType.MaxHandle)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd()">
    <ng-container *ngIf="maxIconTemplate" [ngTemplateOutlet]="maxIconTemplate"></ng-container>
</span>

<div #pointSelector id="step-values" *ngIf="!!stepId">
    <span *ngFor="let step of steps; let i = index" [id]="stepId + step">
        <span> {{ i % stepDivider === 0 ? step : '•' }}</span>
    </span>
</div>
